import type { CollectionQueryState, CollectionQueryAdapter } from '@common/adapters/collection-query';
import type { ChatBotEntity } from '@common/types/chat-bot.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionQueryAdapter } from '@common/adapters/collection-query';

import ChatBotsActions from './chat-bots.actions';

export const CHAT_BOTS_COLLECTION_FEATURE_KEY = 'chatBots';

export type ChatBotsCollectionState = CollectionQueryState<ChatBotEntity[]>;

export const chatBotsAdapter: CollectionQueryAdapter<ChatBotEntity[]> = createCollectionQueryAdapter<ChatBotEntity[]>();

export const chatBotsCollectionReducer = createReducer<ChatBotsCollectionState>(
    chatBotsAdapter.getInitialState(),
    on(ChatBotsActions.loadCollectionRequest, (state: ChatBotsCollectionState, { messenger }) =>
        chatBotsAdapter.loadCollectionQueryRequest(state, messenger)
    ),
    on(ChatBotsActions.loadCollectionSuccess, (state: ChatBotsCollectionState, { messenger, chatBots }) =>
        chatBotsAdapter.loadCollectionQuerySuccess(chatBots, messenger, state)
    ),
    on(ChatBotsActions.loadCollectionFailure, (state: ChatBotsCollectionState, { messenger, error }) =>
        chatBotsAdapter.loadCollectionQueryFailure(error, messenger, state)
    )
);
